/* global axios */
import ApiClient from './ApiClient';

class AutomationEventsAPI extends ApiClient {
  constructor() {
    super('automation_events', { accountScoped: true });
  }

  // Supported list params: exact filters (email, phone, contact_id, launch_id,
  // transaction_id, source, event_type, product/product_code, status, errors,
  // unlinked, from, to), unified free-text `q`, and pagination (page, per_page).
  // Response meta includes status_counts aggregated without the status filter.
  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  upsertStep(eventId, payload) {
    return axios.post(`${this.url}/${eventId}/steps/upsert`, payload);
  }

  retryable(params = {}) {
    return axios.get(`${this.baseUrl()}/automation_steps/retryable`, {
      params,
    });
  }

  retryStep(stepId) {
    return axios.post(`${this.baseUrl()}/automation_steps/${stepId}/retry`);
  }

  listCommands(params = {}) {
    return axios.get(`${this.baseUrl()}/automation_step_commands`, { params });
  }

  showCommand(commandId) {
    return axios.get(`${this.baseUrl()}/automation_step_commands/${commandId}`);
  }
}

export default new AutomationEventsAPI();
